import React, { useEffect, useState, useRef } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next'
import { Space, Image, Typography, Menu, Drawer } from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined
} from '@ant-design/icons'
import viewUtils from "../../../utils/viewUtils";
import Languages from "../../../components/Languages";
import Logo from '../../../common/images/logo.png';
import {
  getMenuApi,
} from "../../../api/WebApi";

const Header = (props: any) => {
  const { i18n } = useTranslation()
  const [ menuData, setMenuData ] = useState<any>();
  const currentMenuRef:any = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    getMenuApi(true).then((res) => {
      if(res.status) {
        setMenuData(res.data)
      }
    })
  }, [])

  const MenuList = [
    ...menuData?.map((menu: any) => {
      if(menu?.page_config?.type === 'about') {
        return {
          key: "about",
          label: viewUtils.prettyWithLang(menu.name, i18n.language),
          to: "/about",
          selected: location.pathname.startsWith(`/about`),
        }
      }
      if(menu?.page_config?.type === 'contact') {
        return {
          key: "contact",
          label: viewUtils.prettyWithLang(menu.name, i18n.language),
          to: "/contact",
          selected: location.pathname.startsWith(`/contact`),
        }
      }
      if(menu?.page_config?.type === 'news') {
        return {
          key: "news",
          label: viewUtils.prettyWithLang(menu.name, i18n.language),
          to: `/menu/${menu.id}/category/${(menu?.categories || [])[0]?.id || ''}`,
          selected: location.pathname.startsWith(`/menu/${menu.id}/category/${(menu?.categories || [])[0]?.id || ''}`),
        }
      }
      return {
        id: menu.id,
        key: `menu-${menu.id}`,
        label: viewUtils.prettyWithLang(menu.name, i18n.language),
        children: menu?.categories?.map((submenu: any) => ({
          id: submenu.id,
          key: `category-${submenu.id}`,
          label: viewUtils.prettyWithLang(submenu.name, i18n.language),
          to: `/menu/${menu.id}/category/${submenu.id}`,
          group: submenu.group,
        })),
        selected: location.pathname.startsWith(`/menu/${menu.id}`),
        maxCount:  Math.max(...(Object.values((menu?.categories || []).reduce((ret: any, item: any) => {
          if(!!ret[item.group || 'null']) {
            ret[item.group || 'null'] += 1
          } else {
            ret[item.group || 'null'] = 1
          }
          return ret;
        }, {})) as number[]))
      }
    }) || [],
  ]

  const handleHoverMenu = (menu: any) => {
    if(!!currentMenuRef.current?.key && currentMenuRef.current?.key !== menu?.key) {
      try {
        document.querySelector(`#header-horizontal-menu-${currentMenuRef.current?.key}`)?.classList.remove("hover");
      } catch(e) {}
      try {
        const element: any = document.querySelector(`#header-horizontal-submenu-${currentMenuRef.current?.key}`);
        if (element) {
          element.style.height = '0px';
          element?.classList.remove("hover");
        }
      } catch(e) {}
    }
    if(!!menu && currentMenuRef.current?.key !== menu?.key) {
      try {
        document.querySelector(`#header-horizontal-menu-${menu.key}`)?.classList.add("hover");
      } catch(e) {}
      try {
        const element: any = document.querySelector(`#header-horizontal-submenu-${menu.key}`);
        if (element) {
          element.style.height = `calc(20px + ${menu?.maxCount || 0} * 1.95em)`;
          element?.classList.add("hover");
        }
      } catch(e) {}
    }
    currentMenuRef.current = menu;
  }

  const VerticalMenu = () => {
    const [menuState, setMenuState] = useState(false)

    const handleMenuOpen = () => {
      setMenuState(true)
    }

    const handleMenuClose = () => {
      setMenuState(false)
    }

    return (
      <>
        {
          !!menuState ?
            <MenuFoldOutlined className='menu-trigger' onClick={handleMenuClose} /> :
            <MenuUnfoldOutlined className='menu-trigger' onClick={handleMenuOpen} />
        }
        <Drawer
          className='menu-drawer'
          // width={"100%"}
          height={"100%"}
          onClose={handleMenuClose}
          placement={'top'}
          open={menuState}
          styles={{
            body: {
              padding: "30px 0"
            }
          }}>
          <Menu
            mode="inline"
            items={MenuList}
            onClick={(e: any) => {
              !!e.item?.props?.to && navigate(e.item?.props?.to);
            }}
            selectedKeys={MenuList?.filter((m: any) => !!m.selected)?.map((m: any) => m.key) || []}
          />
        </Drawer>
      </>
    )
  }

  return (
    <>
      <div className="vertical-header-content">
        <NavLink to='/' className='logo'>
          <Image
            src={Logo}
            preview={false}
          />
        </NavLink>
        <Space size={20}>
          <Languages />
          <VerticalMenu />
        </Space>
      </div>
      <div
        className="horizontal-header-content"
        onMouseMove={(e) => handleHoverMenu(null)}
        onMouseLeave={(e) => handleHoverMenu(null)}>
        <div className='dark-header'>
        </div>
        <div style={{padding: "10px var(--content-padding)"}}>
          <div className='menu-content'>
            <NavLink to='/' className='logo'>
              <Image
                src={Logo}
                preview={false}
              />
            </NavLink>
            <div className='menu'>
              {
                MenuList.map(menu => (
                  <div
                    id={`header-horizontal-menu-${menu.key}`}
                    key={menu.key}
                    className={`menu-item ${menu.selected ? 'active' : ''}  ${menu.key === 'contact' ? "dark" : ''}`}
                    onMouseEnter={(e) => handleHoverMenu(menu)}
                    onMouseMove={(e) => {
                      e.stopPropagation();
                    }}>
                    <div className={`content`}>
                      {
                        !!menu.to ? <NavLink to={menu.to}>
                          <Typography.Text>
                            { menu.label }
                          </Typography.Text>
                        </NavLink> : <Typography.Text>
                          { menu.label }
                        </Typography.Text>
                      }
                    </div>
                    <div className='active-line'></div>
                  </div>
                ))
              }
              <Languages />
            </div>
          </div>
          <div className='submenu' onMouseMove={(e) => {
              e.stopPropagation();
            }}>
            {
              MenuList.filter(menu => (menu?.children?.length || 0) > 0).map(menu => (
                <div
                  id={`header-horizontal-submenu-${menu.key}`}
                  key={menu.key}
                  className={`submenu-item`}
                  >
                  {
                    Object.values((menu.children || []).reduce((ret: any, item: any) => {
                      if(!!ret[item.group || 'null']) {
                        ret[item.group || 'null'].push(item)
                      } else {
                        ret[item.group || 'null'] = [item]
                      }
                      return ret;
                    }, {})).map((item: any, index: number) => (
                      <div key={index} className='submenu-item-btns' style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'}}>
                        {
                          (item || []).map((subItem: any) => (
                            <div
                              className='item'
                              key={subItem.key}
                              onClick={(e: any) => {
                                !!subItem.to && navigate(subItem.to);
                                handleHoverMenu(null)
                              }}>
                              {subItem.label}
                            </div>
                          ))
                        }
                      </div>
                    ))
                  }
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;